import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { fetchClient, formatHeaders } from '@nike/fetch-client';
import { DOTCOM_UX_ID } from '@nike/ux-tread-dotcom-constants';
import getPaypalExpressQueryKey from './get-query-key';
import getWebShellClientLocale from "../../../../utils/get-webshellclient-locale";
import determineUserType from "../../../../utils/determine-user-type";
import getCheckoutHref from "../../../../utils/get-checkout-href";
import getFetchCartOptions from "../../../buy/carts/v2/fetch/get-options";
var appName = 'CiCCart';
export var getPaypalExpressJob = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var id, token, _yield$window$webShel, visitorId, visitId;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          id = _ref.id;
          _context.next = 1;
          return window.webShellClient.identity.getAccessToken();
        case 1:
          token = _context.sent;
          _context.next = 2;
          return window.webShellClient.identity.getVisitData();
        case 2:
          _yield$window$webShel = _context.sent;
          visitorId = _yield$window$webShel.visitorId;
          visitId = _yield$window$webShel.visitId;
          return _context.abrupt("return", fetchClient("".concat(process.env.NEXT_PUBLIC_API_HOST_NAME, "/payment/paypal_express/v2/jobs/").concat(id), {
            method: 'GET',
            credentials: 'include',
            headers: formatHeaders({
              appId: DOTCOM_UX_ID,
              appName: appName,
              token: token,
              visitId: visitId,
              visitorId: visitorId
            })
          }, 'Error retrieving paypal express.', {
            pageActionName: 'tread-paypal-express-event'
          }));
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getPaypalExpressJob(_x) {
    return _ref2.apply(this, arguments);
  };
}();
export var createPaypalExpress = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref3) {
    var totals, items, queryClient, _getWebShellClientLoc, langRegion, country, checkoutHref, _yield$queryClient$fe, cartId, currency, token, _yield$window$webShel2, visitorId, visitId, userType;
    return _regeneratorRuntime.wrap(function (_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          totals = _ref3.totals, items = _ref3.items, queryClient = _ref3.queryClient;
          _getWebShellClientLoc = getWebShellClientLocale(), langRegion = _getWebShellClientLoc.langRegion, country = _getWebShellClientLoc.country;
          checkoutHref = getCheckoutHref({
            queryClient: queryClient
          }) || '';
          _context2.next = 1;
          return queryClient.fetchQuery(getFetchCartOptions({
            queryClient: queryClient
          }));
        case 1:
          _yield$queryClient$fe = _context2.sent;
          cartId = _yield$queryClient$fe.id;
          currency = _yield$queryClient$fe.currency;
          _context2.next = 2;
          return window.webShellClient.identity.getAccessToken();
        case 2:
          token = _context2.sent;
          _context2.next = 3;
          return window.webShellClient.identity.getVisitData();
        case 3:
          _yield$window$webShel2 = _context2.sent;
          visitorId = _yield$window$webShel2.visitorId;
          visitId = _yield$window$webShel2.visitId;
          _context2.next = 4;
          return determineUserType();
        case 4:
          userType = _context2.sent;
          return _context2.abrupt("return", fetchClient("".concat(process.env.NEXT_PUBLIC_API_HOST_NAME, "/payment/paypal_express/v2/"), {
            method: 'POST',
            credentials: 'include',
            headers: _objectSpread({
              'Content-Type': 'application/json; charset=UTF-8'
            }, formatHeaders({
              appId: DOTCOM_UX_ID,
              appName: appName,
              token: token,
              userType: userType,
              visitId: visitId,
              visitorId: visitorId
            })),
            body: JSON.stringify({
              request: {
                country: country.toUpperCase(),
                locale: langRegion,
                currency: currency,
                returnURL: "".concat(checkoutHref, "?cartId=").concat(cartId, "&action=express"),
                cancelURL: checkoutHref,
                totals: totals,
                items: items
              }
            })
          }, 'Error creating link to Paypal Express.', {
            pageActionName: 'tread-paypal-express-event'
          }));
        case 5:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function createPaypalExpress(_x2) {
    return _ref4.apply(this, arguments);
  };
}();
export var getPaypalExpress = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref5) {
    var queryClient, totals, items, job, jobId, MAX_TIMEOUT, timeoutTime, timeNow, response;
    return _regeneratorRuntime.wrap(function (_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          queryClient = _ref5.queryClient, totals = _ref5.totals, items = _ref5.items;
          _context3.next = 1;
          return createPaypalExpress({
            queryClient: queryClient,
            totals: totals,
            items: items
          });
        case 1:
          job = _context3.sent;
          jobId = job === null || job === void 0 ? void 0 : job.id; //This is for CQRS call for services.
          //We have a timeout of 30 seconds to wait for the job to complete
          //If the job is not completed in that time, we throw an error
          MAX_TIMEOUT = 30000;
          timeoutTime = Date.now() + MAX_TIMEOUT; // timeNow tracks the current time in milliseconds and is updated in the loop
          timeNow = Date.now();
        case 2:
          _context3.next = 3;
          return getPaypalExpressJob({
            id: jobId
          });
        case 3:
          response = _context3.sent;
          if (!(response.status !== 'COMPLETED')) {
            _context3.next = 5;
            break;
          }
          _context3.next = 4;
          return new Promise(function (resolve) {
            return setTimeout(resolve, 200);
          });
        case 4:
          // Wait for 200ms before updating time
          timeNow = Date.now();
          _context3.next = 6;
          break;
        case 5:
          return _context3.abrupt("return", response);
        case 6:
          if (timeNow < timeoutTime) {
            _context3.next = 2;
            break;
          }
        case 7:
          throw new Error('Timeout error');
        case 8:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function getPaypalExpress(_x3) {
    return _ref6.apply(this, arguments);
  };
}();
var getPaypalExpressOptions = function getPaypalExpressOptions(_ref7) {
  var queryClient = _ref7.queryClient,
    items = _ref7.items,
    totals = _ref7.totals;
  return {
    queryKey: getPaypalExpressQueryKey({
      queryClient: queryClient,
      items: items,
      totals: totals
    }),
    queryFn: function queryFn() {
      return getPaypalExpress({
        queryClient: queryClient,
        items: items,
        totals: totals
      });
    },
    onError: function onError(error) {
      if (window.newrelic && window.newrelic.addPageAction) {
        window.newrelic.addPageAction('paypal_express/v2-error', {
          message: error.message,
          error: error
        });
      }
    }
  };
};
export default getPaypalExpressOptions;